module.exports = __webpack_public_path__ + "9788f41e/img/scraper-icon.df6ccde5.svg";